import { DateUtils, Simulation } from "@mra/hlp9002";
import { PreconisationModifiee } from "../models/preconisationModifiee.model";

export class SimuUtils {
  public static getDateEffet(configUti: PreconisationModifiee, simu: Simulation): string {
    return configUti?.dateEffet
      ? configUti?.dateEffet
      : (simu?.contrat?.dateEffetInitiale ?? DateUtils.now().format("YYYY-MM-DD"));
  }
}
